import React from 'react';
import { motion } from 'framer-motion';
import { Gift, HeartHandshake, CalendarDays, ShieldAlert, MessagesSquare, ListChecks, BoxIcon } from 'lucide-react';
export function SixBonos() {
  const bonos = [{
    num: 'BONO 1',
    title: '100 Preguntas Clave para la Primera Sesión de Postparto',
    val: '$12.000',
    Icon: BoxIcon,
    tint: 'bg-terracotta/10 text-terracotta'
  }, {
    num: 'BONO 2',
    title: 'Kit Completo de Psicoeducación para Mamás en Postparto',
    val: '$10.000',
    Icon: HeartHandshake,
    tint: 'bg-gold/15 text-gold-700'
  }, {
    num: 'BONO 3',
    title: 'Calendario de Seguimiento: Las Primeras 12 Semanas Organizadas',
    val: '$9.000',
    Icon: CalendarDays,
    tint: 'bg-sage/15 text-sage-700'
  }, {
    num: 'BONO 4',
    title: 'Protocolo de Crisis Postparto: Qué Hacer Cuando No Sabés Qué Hacer',
    val: '$10.000',
    Icon: ShieldAlert,
    tint: 'bg-red-100 text-red-600'
  }, {
    num: 'BONO 5',
    title: 'Comunicación que Sostiene: Mensajes, Frases y Recursos para Acompañar entre Sesiones',
    val: '$9.000',
    Icon: MessagesSquare,
    tint: 'bg-navy/10 text-navy'
  }, {
    num: 'BONO 6',
    title: 'Checklist de la Profesional Organizada: Tu Rutina Clínica Semanal',
    val: '$8.000',
    Icon: ListChecks,
    tint: 'bg-terracotta/10 text-terracotta-700'
  }];
  return <section className="py-12 md:py-24 px-4 sm:px-6 lg:px-8 bg-terracotta-50" data-id="element-275">
      <div className="max-w-5xl mx-auto" data-id="element-276">
        <div className="text-center mb-8 md:mb-14" data-id="element-277">
          <div className="inline-flex items-center gap-1.5 md:gap-2 px-3 py-1.5 md:px-4 md:py-2 rounded-full bg-terracotta/10 text-terracotta-700 font-bold text-xs md:text-sm mb-4 md:mb-6" data-id="element-278">
            <Gift className="w-3 h-3 md:w-4 md:h-4" data-id="element-279" />
            Incluidos en todas las ofertas — sin costo extra —
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-navy mb-2 md:mb-4" data-id="element-280">
            MÁS LOS 6 BONOS ESTRATÉGICOS
          </h2>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-3 gap-2.5 md:gap-4 mb-8 md:mb-14" data-id="element-281">
          {bonos.map((bono, i) => {
          const Icon = bono.Icon;
          return <motion.div key={i} initial={{
            opacity: 0,
            y: 12
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-30px'
          }} transition={{
            duration: 0.35,
            delay: i % 3 * 0.08
          }} whileHover={{
            y: -3
          }} className="group relative bg-white rounded-2xl p-3 md:p-5 shadow-sm border border-terracotta/10 flex flex-col h-full overflow-hidden" data-id="element-282">
                {/* GRATIS badge */}
                <div className="absolute top-2 right-2 md:top-3 md:right-3 bg-terracotta text-white text-[9px] md:text-[10px] font-bold px-1.5 py-0.5 rounded uppercase tracking-wider z-10" data-id="element-283">
                  GRATIS
                </div>

                {/* Icon thumbnail — pure SVG, no network load */}
                <div className={`${bono.tint} aspect-square w-full rounded-xl flex items-center justify-center mb-3 md:mb-4 transition-transform duration-300 group-hover:scale-[1.03]`} aria-hidden="true" data-id="element-284">
                  <Icon className="w-10 h-10 md:w-14 md:h-14" strokeWidth={1.5} data-id="element-285" />
                </div>

                <div className="text-[9px] md:text-[10px] font-bold tracking-wider text-terracotta/70 mb-1" data-id="element-286">
                  {bono.num}
                </div>
                <h3 className="text-[13px] md:text-sm font-bold text-navy leading-snug mb-2 md:mb-3 line-clamp-3" data-id="element-287">
                  {bono.title}
                </h3>

                <div className="mt-auto flex items-baseline gap-1.5 text-[11px] md:text-xs font-medium" data-id="element-288">
                  <span className="text-navy/40 line-through" data-id="element-289">{bono.val}</span>
                  <span className="text-terracotta font-bold" data-id="element-290">→ GRATIS</span>
                </div>
              </motion.div>;
        })}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-terracotta text-white rounded-2xl md:rounded-3xl p-5 md:p-8 text-center shadow-xl shadow-terracotta/20" data-id="element-291">
          <p className="text-sm md:text-xl font-medium mb-1 md:mb-2 opacity-90" data-id="element-292">
            Valor total de los 6 bonos: $58.000
          </p>
          <p className="text-xl md:text-4xl font-bold" data-id="element-293">
            🎁 GRATIS — Incluidos siempre
          </p>
        </motion.div>
      </div>
    </section>;
}